import { render, staticRenderFns } from "./downloadApp.vue?vue&type=template&id=09a5e3c6&scoped=true"
import script from "./downloadApp.vue?vue&type=script&lang=js"
export * from "./downloadApp.vue?vue&type=script&lang=js"
import style0 from "./downloadApp.vue?vue&type=style&index=0&id=09a5e3c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a5e3c6",
  null
  
)

export default component.exports